.spinner {
  display: inline-block;
  border-radius: var(--radius-full);
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-right-color: currentColor;
  animation: spin 0.6s linear infinite;
  box-sizing: border-box;
}

.sm {
  width: 16px;
  height: 16px;
  border-width: 2px;
}

.md {
  width: 24px;
  height: 24px;
  border-width: 2.5px;
}

.lg {
  width: 40px;
  height: 40px;
  border-width: 3px;
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
